export default __webpack_public_path__ + "static/iciciRm-0033adaf12e2ee8ce4c98ee675d4e7bd.png";